import { ILogData, LogEventNames } from "./ITelemetryLogger";

/**
 * Decides the type of duration measurement desired
 */
export enum DurationMeasureType {
    // This simply logs the duration between calls to the pair - BeginDurationMeasure, EndDurationMeasure
    Normal,

    // This logs only the slowest duration (ever measured so far) across multiple calls to the pair - BeginDurationMeasure, EndDurationMeasure
    Slowest,

    // This logs the accumulated time splits (measured so far) across multiple calls to the pair - BeginDurationMeasure, EndDurationMeasure
    Accumulated
};

/**
 * Interface that represents an event to be logged
 * An "event" is the thing that gets emitted, which will have a separate row in Kusto eventually.
 * Caller should call Start and End to ensure the full event is logged
 */
export interface ILogEvent<T extends string>{
    Start(additionalData?: ILogData<T>[]);
    End(additionalData?: ILogData<T>[]): string;

    AddData(data: ILogData<T>[]);
    BeginDurationMeasure(type: DurationMeasureType, key: T);
    EndDurationMeasure(key: T);
    IncrementCount(key: T);
    GetEventName(): LogEventNames;
}